import { ActionIcon } from '@mantine/core';
import { useLocalStorage } from 'react-use';
import BreadCrumbs from '../BreadCrumbs/BreadCrumbs';
import EditorsChoice from '../EditorsChoice/EditorsChoice';
import Logo from '../Logo/Logo';
import SplitButton from '../SplitButton/SplitButton';
import { ButtonGroup, NextPrevArrows } from './TopBarEditor.components';
import { downloadOptions } from './TopBarEditor.data';
import { Gap, Right, Wrapper } from './TopBarEditor.style';

export type TopBarEditorProps = {
  section: string;
  data: {
    breadcrumbs: Json[];
    version: string;
    nextPrevModels: Json;
    generatorId?: string;
    user: IUser;
    isPlayground: boolean;
    isCharging: boolean;
    totalGoldens: number;
  };
  callbacks: {
    onLogoClick: () => void;
    onAction: OnAction;
    onNavigate: (path: string) => void;
    toggleLogs: () => void;
    onPreview: () => void;
  };
  children?: React.ReactNode;
};

export function TopBarEditor(props: TopBarEditorProps) {
  const { data, callbacks, section = 'editor' } = props;
  const { breadcrumbs = [], user, version, generatorId, totalGoldens } = data;
  const [fileFormat, setFileFormat] = useLocalStorage('FILE_FORMAT', 'GLB');

  function renderEditorsChoice() {
    if (!user.isEmployee && !user.isReviewer) return null;
    return <EditorsChoice total={totalGoldens} onAction={callbacks.onAction} />;
  }

  return (
    <Wrapper className='TopBarEditor-wrapper' data-testid='TopBarEditor-wrapper'>
      <Logo tagline={section} version={version} onClick={callbacks.onLogoClick} />
      <BreadCrumbs value='' items={breadcrumbs} badge={generatorId} />
      <NextPrevArrows {...props} />
      <Gap />
      {props.children}
      <Gap />
      {renderEditorsChoice()}
      <Gap />
      <ButtonGroup {...props} pos='center' />
      <Right>
        <ActionIcon.Group>
          <ButtonGroup {...props} pos='right' />
        </ActionIcon.Group>
        <SplitButton
          iconName='IconDownload'
          options={downloadOptions}
          value={fileFormat}
          isLoading={data.isCharging}
          onChange={setFileFormat}
          onClick={(fileFormat) =>
            callbacks.onAction({ type: 'EDITOR', verb: 'download', payload: { fileFormat } })
          }
        />
      </Right>
    </Wrapper>
  );
}

export default TopBarEditor;
